
import React from 'react';
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface Service {
  service_id: string;
  service_name: string;
  default_price: number;
  parent_service_id?: string;
}

interface ServiceItemProps {
  service: Service;
  isSelected: boolean;
  canSelect: boolean;
  price: number | undefined | null;
  onSelectionChange: (service: Service, selected: boolean) => void;
  onPriceChange: (serviceId: string, value: string) => void;
  isChild?: boolean;
}

const ServiceItem: React.FC<ServiceItemProps> = ({
  service,
  isSelected,
  canSelect,
  price,
  onSelectionChange,
  onPriceChange,
  isChild = false
}) => {
  return (
    <div 
      className={cn(
        "flex flex-col space-y-2 p-4 border rounded-md bg-background transition-colors",
        isSelected && "border-primary/50 bg-primary/5",
        isChild && "border-dashed",
        !canSelect && "opacity-60"
      )}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center space-x-2">
          <Checkbox
            id={`service-${service.service_id}`}
            checked={isSelected}
            onCheckedChange={(checked) => {
              if (canSelect) {
                onSelectionChange(service, checked === true);
              }
            }}
            disabled={!canSelect}
            className="h-4 w-4"
          />
          <div>
            <label 
              htmlFor={`service-${service.service_id}`}
              className={cn(
                "font-medium cursor-pointer",
                !canSelect && "text-muted-foreground"
              )}
            >
              {service.service_name}
            </label>
            {!canSelect && isChild && (
              <p className="text-xs text-amber-600 mt-1">
                Requires parent service
              </p>
            )}
          </div>
        </div>
        <div className="text-sm font-semibold">
          ${service.default_price.toFixed(2)}
        </div>
      </div>
      
      {isSelected && (
        <div className="pt-2 pl-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Price
          </label>
          <Input
            type="number"
            step="0.01"
            value={price !== undefined && price !== null ? price : ""}
            onChange={(e) => onPriceChange(service.service_id, e.target.value)}
            placeholder={service.default_price.toFixed(2)}
            className="w-full md:w-1/3"
          />
        </div>
      )}
    </div>
  );
};

export default ServiceItem;
